module.exports = __webpack_public_path__ + "img/bankTransfer3.2a9e4fc8.png";